var map = {
	"./assignment/assignment.module": [
		"../../../../../src/app/components/googleClassroom/assignment/assignment.module.ts",
		"assignment.module"
	],
	"./authentication/authentication.module": [
		"../../../../../src/app/authentication/authentication.module.ts",
		"authentication.module"
	],
	"./components/attendance/attendance.module": [
		"../../../../../src/app/components/attendance/attendance.module.ts",
		"attendance.module"
	],
	"./components/batch/batch.module": [
		"../../../../../src/app/components/batch/batch.module.ts",
		"batch.module"
	],
	"./components/calendar/calendar.module": [
		"../../../../../src/app/components/calendar/calendar.module.ts",
		"calendar.module"
	],
	"./components/course/course.module": [
		"../../../../../src/app/components/course/course.module.ts",
		"course.module"
	],
	"./components/dataAnalytics/dataAnalytics.module": [
		"../../../../../src/app/components/dataAnalytics/dataAnalytics.module.ts",
		"dataAnalytics.module"
	],
	"./components/forum/forum.module": [
		"../../../../../src/app/components/forum/forum.module.ts",
		"forum.module"
	],
	"./components/google-meet/google-meet.module": [
		"../../../../../src/app/components/google-meet/google-meet.module.ts",
		"google-meet.module"
	],
	"./components/googleClassroom/assignment/assignment.module": [
		"../../../../../src/app/components/googleClassroom/assignment/assignment.module.ts",
		"assignment.module"
	],
	"./components/googleClassroom/googleClassrom.module": [
		"../../../../../src/app/components/googleClassroom/googleClassrom.module.ts",
		"googleClassrom.module"
	],
	"./components/manageuser/manageuser.module": [
		"../../../../../src/app/components/manageuser/manageuser.module.ts",
		"manageuser.module"
	],
	"./components/noticeboard/noticeboard.module": [
		"../../../../../src/app/components/noticeboard/noticeboard.module.ts",
		"noticeboard.module"
	],
	"./components/parentchild/parentchild.module": [
		"../../../../../src/app/components/parentchild/parentchild.module.ts",
		"parentchild.module"
	],
	"./components/settings/settings.module": [
		"../../../../../src/app/components/settings/settings.module.ts",
		"settings.module"
	],
	"./components/soundingboardinbox/soundingboardinbox.module": [
		"../../../../../src/app/components/soundingboardinbox/soundingboardinbox.module.ts",
		"soundingboardinbox.module"
	],
	"./components/teachers/teachers.module": [
		"../../../../../src/app/components/teachers/teachers.module.ts",
		"teachers.module"
	],
	"./dashboard/dashboard.module": [
		"../../../../../src/app/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"./layouts/UserProfile/userProfile.module": [
		"../../../../../src/app/layouts/UserProfile/userProfile.module.ts",
		"userProfile.module"
	],
	"./login/login.module": [
		"../../../../../src/app/authentication/login/login.module.ts",
		"login.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main